module.exports = () => ({
  /**
   * H1
   * Vattenfall Hall Display
   * Desktop/Tablet 52px/62px (dt)
   * Mobile 34px/40px (mo)
   */
  ".h1-mo": { "@apply ds-text-5xl ds-leading-2xl ds-font-display ds-font-bold": 1 },
  ".h1-dt": { "@apply ds-text-7xl ds-leading-4xl ds-font-display ds-font-bold": 1 },
  "h1, .h1": { "@apply ds-h1-mo sm:!ds-h1-dt": 1 },

  /**
   * H2
   * Vattenfall Hall Display
   * Desktop/Tablet 36px/42px (dt)
   * Mobile 28px/32px (mo)
   */
  ".h2-mo": { "@apply ds-text-4xl ds-leading-lg ds-font-display ds-font-bold": 1 },
  ".h2-dt": { "@apply ds-text-6xl ds-leading-3xl ds-font-display ds-font-bold": 1 },
  "h2, .h2": { "@apply ds-h2-mo sm:!ds-h2-dt": 1 },

  /**
   * H3
   * Vattenfall Hall
   * Desktop/Tablet 28px/36px (dt)
   * Mobile 22px/28px (mo)
   */
  ".h3-mo": { "@apply ds-text-2xl ds-leading-base ds-font-regular ds-font-bold": 1 },
  ".h3-dt": { "@apply ds-text-4xl ds-leading-xl ds-font-regular ds-font-bold": 1 },
  "h3, .h3": { "@apply ds-h3-mo sm:!ds-h3-dt": 1 },

  /**
   * H4
   * Vattenfall Hall
   * Desktop/Tablet 22px/28px (dt)
   * Mobile 18px/24px (mo)
   */
  ".h4-mo": { "@apply ds-text-lg ds-leading-sm ds-font-regular ds-font-bold": 1 },
  ".h4-dt": { "@apply ds-text-2xl ds-leading-base ds-font-regular ds-font-bold": 1 },
  "h4, .h4": { "@apply ds-h4-mo sm:!ds-h4-dt": 1 },
});
